<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{}
  },

}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
html,body{
  margin: 0;
  padding: 0;
}

</style>
